import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Link, Redirect, Route, Switch} from "react-router-dom";
import NotFound from "../components/NotFound";
import IntManager, {t} from '../IntManager';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {setCameFromSlide, setLanguage, setMainPageIndex} from "../reducers/app";
import $ from "jquery";
import {TimelineLite} from 'gsap';

const scrollListener = (e) => {
    const st = $(e.target).scrollTop();
    const sticky = $('#header-sticky');

    if (window.matchMedia("(min-width: 768px)").matches) {
        if (st > window.innerHeight) {
            sticky.addClass('is-visible');
        } else {
            sticky.removeClass('is-visible');
        }
    } else {

    }
};

class LayoutComponent extends Component {
    constructor(props, context) {
        super(props, context);

        this.renderHeader = this.renderHeader.bind(this);
        this.state = {
            redirect: null
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', scrollListener);
        this.createModalAd();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', scrollListener);
    }

    createModalAd() {
        // function getCookie(name) {
        //     var matches = document.cookie.match(new RegExp(
        //         "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        //     ));
        //     return matches ? decodeURIComponent(matches[1]) : undefined;
        // }
        //
        // function setCookie(name, value, options) {
        //     options = options || {};
        //
        //     var expires = options.expires;
        //
        //     if (typeof expires === "number" && expires) {
        //         var d = new Date();
        //         d.setTime(d.getTime() + expires * 1000);
        //         expires = options.expires = d;
        //     }
        //     if (expires && expires.toUTCString) {
        //         options.expires = expires.toUTCString();
        //     }
        //
        //     value = encodeURIComponent(value);
        //
        //     var updatedCookie = name + "=" + value;
        //
        //     for (var propName in options) {
        //         updatedCookie += "; " + propName;
        //         var propValue = options[propName];
        //         if (propValue !== true) {
        //             updatedCookie += "=" + propValue;
        //         }
        //     }
        //
        //     document.cookie = updatedCookie;
        // }
    }

    renderHeader() {
        if (this.props.renderHeader) {
            return this.props.renderHeader();
        }

        const isRU = IntManager.getLanguage() === 'ru';
        const links = [
            {
                id: 1,
                url: IntManager.getUrl('/'),
                title: t('stations'),
                onClick: () => {
                    this.props.setMainPageIndex(1);
                    return false;
                }
            },
            {
                id: 2,
                url: IntManager.getUrl('/news'),
                title: t('news')
            },
            {
                id: 3,
                url: IntManager.getUrl('/media'),
                title: t('media')
            },
            {
                id: 4,
                url: IntManager.getUrl('/about'),
                title: t('park')
            },
            {
                id: 5,
                url: IntManager.getUrl('/contacts'),
                title: t('contacts')
            },
            {
                id: 6,
                url: isRU ? '/en' : '/',
                title: isRU ? IntManager.getLanguageTitle('en') : IntManager.getLanguageTitle('ru')
            }
        ];

        function toggleNav(e) {
            const menuButton = $('.hamburger');
            const mobileMenu = $('.mobile-overlay');
            const tl = new TimelineLite({paused: true});
            const nav = $('.nav');

            e.stopPropagation();

            menuButton.toggleClass('is_active');
            nav.toggleClass('is_open');
            tl.fromTo(mobileMenu, .3, {autoAlpha: 0, display: 'none'}, {autoAlpha: 1, display: 'block'})
                .staggerFromTo('.mobile-nav__link', .3, {autoAlpha: 0, y: -13}, {autoAlpha: 1, y: 0}, .1,);

            if (nav.hasClass('is_open')) {
                tl.play(0);
            } else {
                tl.reverse(100);
            }
        }


        return <div>
            <header className="header">
                <div className="header__container">
                    <div className="logo" onClick={() => {
                        if (this.props.onLogoClick) {
                            this.props.onLogoClick();
                            return;
                        }

                        this.props.setCameFromSlide(false);
                        this.props.setMainPageIndex(0);

                        this.setState({
                            redirect: IntManager.getUrl('/')
                        });
                    }}>
                        <svg className="logo__icon">
                            <use xlinkHref="/static/media/svg-symbols.svg#logo1"/>
                        </svg>
                        {this.props.navReverse ? (
                            <svg className="logo__text">
                                <use xlinkHref="/static/media/svg-symbols.svg#logo2"/>
                            </svg>
                        ) : (
                            <svg className="logo__text">
                                <use xlinkHref="/static/media/svg-symbols.svg#logo3"/>
                            </svg>
                        )}
                    </div>
                    <div className={(this.props.navReverse ? 'hamburger--black ' : '') + 'hamburger phone-only'}
                         onClick={toggleNav}>
                        <div className="hamburger__bar"></div>
                    </div>
                    <div className="mobile-overlay phone-only" onClick={(e) => {
                        if (e.target.classList.contains('mobile-overlay')) {
                            toggleNav(e);
                        }
                    }}>
                        <div className="mobile-overlay__content">
                            <div className="mobile-nav">
                                {links.map((link) => {
                                    return <Link to={link.url} key={link.id} onClick={link.onClick}
                                                 className={"mobile-nav__link u-block" + (this.props.routerMatch.url === link.url ? ' active' : '')}>
                                        {link.title}
                                    </Link>
                                })}
                            </div>
                        </div>
                    </div>
                    <div
                        className={(this.props.navReverse ? 'u-color--black ' : 'u-color--white ') + 'nav__list  u-overflow-h hide-phone'}>
                        {links.map((link) => {
                            return <Link to={link.url} key={link.id} onClick={link.onClick}
                                         className={"menu__list-item u-inline-block relative u-overflow-h" + (this.props.routerMatch.url === link.url ? ' active' : '')}>
                                <span className="menu-item__label relative u-block">{link.title}</span>
                                <span className="menu-item__label relative u-block">{link.title}</span>
                            </Link>
                        })}
                    </div>
                </div>
            </header>
            <header id="header-sticky" className="header-sticky u-pos-tl u-fit-w u-fixed u-overflow-h">
                <div className="header__container">
                    <div className="logo" onClick={() => {
                        if (this.props.onLogoClick) {
                            this.props.onLogoClick();
                            return;
                        }

                        this.props.setCameFromSlide(false);
                        this.props.setMainPageIndex(0);

                        this.setState({
                            redirect: IntManager.getUrl('/')
                        });
                    }}>
                        <svg className="logo__icon--small">
                            <use xlinkHref="/static/media/svg-symbols.svg#logo1"/>
                        </svg>
                        <svg className="logo__text--small">
                            <use xlinkHref="/static/media/svg-symbols.svg#logo2"/>
                        </svg>
                    </div>
                    <div className="nav__list u-overflow-h hide-phone u-color--black">
                        {links.map((link) => {
                            return <Link to={link.url} key={link.id} onClick={link.onClick}
                                         className={"menu__list-item u-inline-block relative u-overflow-h" + (this.props.routerMatch.url === link.url ? ' active' : '')}>
                                <span className="menu-item__label relative u-block">{link.title}</span>
                                <span className="menu-item__label relative u-block">{link.title}</span>
                            </Link>
                        })}
                    </div>
                </div>
            </header>
        </div>
    }

    renderLayout() {
        return <div className="nav js-reverse-trigger">
            {this.renderHeader()}
            {this.props.footer}
            {this.props.extraContent}
        </div>;
    }

    renderLoading() {
        return <div className="u-fit u-fixed">Loading...</div>;
    }

    render() {
        if (this.state.redirect && this.props.routerMatch.url !== this.state.redirect) {
            return <Redirect push to={this.state.redirect}/>;
        }

        const language = this.props.routerMatch.params.lang;

        if (IntManager.setLanguage(language, this.props.setLanguage) === false && !this.props.disableLanguageRedirect) {
            return <Switch>
                <Route component={NotFound}/>
            </Switch>
        }

        let content;

        if (this.props.loadingData) {
            content = this.renderLoading();
        } else {
            content = this.props.children;
        }

        return (
            <React.Fragment>
                {content}
                {this.renderLayout()}
            </React.Fragment>
        );
    }
}


LayoutComponent.propTypes = {
    loadingData: PropTypes.bool,
    disableLanguageRedirect: PropTypes.bool,
    renderLogo: PropTypes.func,
    setLanguage: PropTypes.func,
    onLogoClick: PropTypes.func,
    setCameFromSlide: PropTypes.func,
    setMainPageIndex: PropTypes.func,
    navReverse: PropTypes.bool,
    hideNav: PropTypes.bool,
    footer: PropTypes.any,
    extraContent: PropTypes.any,
    routerMatch: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    return {
        loadingData: state.app.loadingData
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setLanguage,
    setMainPageIndex,
    setCameFromSlide
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);


// WEBPACK FOOTER //
// ./src/js/common/LayoutComponent.js